import assert from '@/sui/tools/assert'

import moment from 'moment'

function getClosurePanelStyle (valid) {
  return valid ? 'bactADI' : 'expADI'
}

function getClasses (valid, nonValidIcon = 'remove', nonValidText = 'danger') {
  const icon = valid ? 'ok' : nonValidIcon
  const text = valid ? 'success' : nonValidText
  return `glyphicon glyphicon-${icon} text-${text}`
}

function getStatusText (valid) {
  return valid ? '' : 'NON '
}

function getSubtitle (closed, isCurrentYear, closureDate) {
  if (closed) {
    return `Participation confirmée`
  }

  if (isCurrentYear) {
    return `Participez avant le ${closureDate}`
  }

  return 'Programme terminé'
}

function getValidationStateDisplay (cvtStatus) {
  if (cvtStatus !== 2 && cvtStatus !== 3) {
    const style = cvtStatus === 1 ? 'info' : 'expADI'
    return {
      valid: false,
      text: `En attente de validation`,
      classes: `glyphicon glyphicon-time text-${style}`,
      style: style
    }
  }

  if (cvtStatus === 2) {
    return {
      valid: true,
      text: 'Acceptée',
      classes: getClasses(true),
      style: 'bactADI'
    }
  }

  return {
    valid: false,
    text: 'Refusée',
    classes: getClasses(false),
    style: 'danger'
  }
}

function getCvtRecap (cvt, closureDate) {
  const status = cvt.stat
  const states = {
    sign: [1, 2, 4].includes(status),
    submit: [1, 2].includes(status),
    validation: getValidationStateDisplay(status)
  }
  const isConvention =
        cvt.bio.stat === 0 && cvt.dir.stat === 0 && cvt.reg.stat === 0
  const checkList = {
    alertType: 'light',
    items: [
      {
        label: `Signataires ${getStatusText(states.sign)}désignés`,
        classes: getClasses(states.sign, 'edit', 'warning')
      },
      {
        label: isConvention
          ? `Charte ${getStatusText(states.submit)}envoyée`
          : `Avenant.s ${getStatusText(states.submit)}envoyé.s`,
        classes: getClasses(states.submit, 'edit', 'warning')
      }
    ]
  }

  if ((states.sign && states.submit) || status === 3) {
    checkList.items.push(
      {
        label: `${states.validation.text} par l'équipe SPIADI`,
        classes: states.validation.classes
      }
    )
  }

  return {
    title: `Charte d'engagement`,
    subtitle: [0, 4].includes(status)
      ? `À envoyer avant le ${closureDate}`
      : states.validation.text,
    style: states.validation.style,
    checkList: [checkList]
  }
}

function getModalityStatus (
  atLeastOneModalityClosed,
  validEstbSheet,
  validTuSheet
) {
  const status = atLeastOneModalityClosed &&
      validEstbSheet
  return validTuSheet
    ? status && validTuSheet : status
}

function getRecap (
  datasetName, moduleNames, modulesInfo, surveillanceModules,
  isCurrentYear, closureDate, validEstablishmentSheet,
  title, validStep, requireEstbSheet
) {
  const closedItems = []
  const allItems = []
  const openItems = []
  let hideClosureDates = false
  for (let i = 0; i !== moduleNames.length; ++i) {
    const m = moduleNames[i]
    assert.notNull(m)

    const info = modulesInfo[m]
    assert.notNull(info)
    assert.notNull(info.needClosure)
    if (!info.needClosure) {
      continue
    }

    const label = `<span class="label label-${m}">${info.label}</span>`
    const dset = surveillanceModules[m].dset.find(
      d => d.name === datasetName
    )
    const closed = dset != null && dset.step === validStep
    const closureDate = closed ? moment(dset.initialStepCompleteDate) : null
    const modalityLabel = `${label} ${getStatusText(closed)}clôturée`
    const classes = getClasses(closed)
    const item = {
      label: modalityLabel,
      classes: classes,
      closureDate: closed ? closureDate.format(`DD/MM/YYYY`) : null
    }
    allItems.push(item)
    if (closed) {
      hideClosureDates = hideClosureDates || closureDate.year() === 1
      closedItems.push(item)
    } else {
      openItems.push(item)
    }
  }

  const atLeastOneModalityClosed = closedItems.length >= 1
  const surveillanceStatus = getModalityStatus(
    atLeastOneModalityClosed,
    requireEstbSheet ? validEstablishmentSheet : true
  )

  const checkList = {
    alertType: 'light',
    items: requireEstbSheet ? [
      {
        label: `Fiche établissement ${getStatusText(validEstablishmentSheet)}validée`,
        classes: getClasses(validEstablishmentSheet)
      }
    ] : []
  }

  const checkLists = [checkList]
  if (!surveillanceStatus) {
    checkList.items.push(...allItems)
  } else {
    checkList.items.push(...closedItems)
    if (openItems.length > 0) {
      checkLists.push(
        {
          subtitle: `<strong>Merci de clôturer (ou désinscrire) les modalités suivantes :
</strong>`,
          alertType: 'warning',
          items: openItems
        }
      )
    }
  }

  return {
    title: title,
    subtitle: getSubtitle(
      surveillanceStatus,
      isCurrentYear,
      closureDate
    ),
    showClosureDates: !hideClosureDates,
    style: getClosurePanelStyle(surveillanceStatus),
    checkList: checkLists
  }
}

function getSurveillanceRecap (
  datasetName, moduleNames, modulesInfo, surveillanceModules,
  isCurrentYear, closureDate, validEstablishmentSheet
) {
  return getRecap(
    datasetName, moduleNames, modulesInfo, surveillanceModules,
    isCurrentYear, closureDate, validEstablishmentSheet,
    `Surveillance`, 2, true
  )
}

function getObservationRecap (
  dsetn, modules, modulesInfo, surveillanceModules,
  isCurrentYear, closureDate, validEstablishmentSheet,
  requireEstbSheet
) {
  return getRecap(
    dsetn, modules, modulesInfo, surveillanceModules,
    isCurrentYear, closureDate, validEstablishmentSheet,
    `Observations des pratiques`, 1,
    requireEstbSheet
  )
}

function getCauseAnalysisRecap (
  dsetn, modules, modulesInfo, surveillanceModules,
  isCurrentYear, closureDate, validEstablishmentSheet,
  requireEstbSheet
) {
  return getRecap(
    dsetn, modules, modulesInfo, surveillanceModules,
    isCurrentYear, closureDate, validEstablishmentSheet,
    `Analyse des causes`, 1,
    requireEstbSheet
  )
}

function getSimpleRecap (
  valid, isCurrentYear, closureDate, title, sheetLabel
) {
  return {
    title: title,
    subtitle: getSubtitle(valid, isCurrentYear, closureDate),
    style: getClosurePanelStyle(valid),
    checkList: [
      {
        alertType: 'light',
        items: [
          {
            label: `${sheetLabel} ${getStatusText(valid)}validée`,
            classes: getClasses(valid)
          }
        ]
      }
    ]
  }
}

function getFormationRecap (valid, isCurrentYear, closureDate) {
  return getSimpleRecap(
    valid, isCurrentYear, closureDate, 'Formation', 'Fiche Formation'
  )
}

function getEstablishmentRecap (valid, isCurrentYear, closureDate) {
  return getSimpleRecap(
    valid, isCurrentYear, closureDate, 'Fiche Établissement', 'Fiche Établissement'
  )
}

export default {
  getCvtRecap,
  getSurveillanceRecap,
  getObservationRecap,
  getCauseAnalysisRecap,
  getFormationRecap,
  getEstablishmentRecap
}
